class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.showOnHover = this.hasAttribute('show-on-hover');
    this.isHovered = false;

    if (!this.showOnHover) {
      this.addEventListener('keyup', this.onKeyUpEscape);
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
      this.onClickOutOfMenuBound = this.onClickOutOfMenu.bind(this);
    } else {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.onClickOutOfMenuBound = this.onClickOutOfMenu.bind(this);
      this.addEventListener('focusout', this.onFocusOut.bind(this));
    }
  }

  onFocusOut() {
    document.addEventListener('click', this.onClickOutOfMenuBound);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    document.removeEventListener('click', this.onClickOutOfMenuBound);
  }

  onClickOutOfMenu(e) {
    setTimeout(() => {
      this.contains(e.target) || this.closeDetails();
    });
  }

  onKeyUpEscape(e) {
    if ('ESCAPE' !== e.code.toUpperCase()) return;
    const t = e.target.closest('details[open]');
    if (!t) return;
    const s = t.querySelector('summary');
    t.removeAttribute('open'), s.focus();
  }

  onMouseEnter() {
    this.isHovered = true;
    this.openDetails();
  }

  onMouseLeave() {
    this.isHovered = false;
  }

  openDetails() {
    this.mainDetailsToggle.setAttribute('open', '');
    document.addEventListener('click', this.onClickOutOfMenuBound);
    document.querySelectorAll('details-disclosure[show-on-hover]').forEach((el) => {
      if (el !== this) {
        el.closeDetails();
      }
    });
  }

  closeDetails() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.removeAttribute('open');
    }
    document.removeEventListener('click', this.onClickOutOfMenuBound);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
